import React, { useState, useEffect } from "react";
import WarningIcon from "../../svg/WarningIcon";
import { Modal } from "@mui/material";
import { color } from "../../styles";

import {
    ModalWrapper,
    TitleText,
    WarningText,
    TitleWrapper,
    StyledBackdrop,
} from "./Styled";
import CustomButton from "../TitleRow/CustomButton";

interface CancelModalProps {
    open: boolean;
    handleClose: () => void;
    handleConfirm: () => void;
    handleCancel?: () => void;
    title?: string;
    contentText?: string;
    closeButtonText?: string;
    confirmButtonText?: string;
    cancelButtonText?: string;
    showCancelButton?: boolean;
    dangerous?: boolean;
    isLoading?: boolean;
}

const CancelModal = ({
    open,
    handleConfirm,
    handleClose,
    handleCancel,
    title,
    contentText,
    closeButtonText = "Đóng",
    confirmButtonText = "Xác Nhận",
    cancelButtonText = "Tiếp tục chỉnh sửa",
    showCancelButton = false,
    dangerous = false,
    isLoading = false,
}: CancelModalProps) => {
    const [isOpen, setIsOpen] = useState(open);

    useEffect(() => {
        if (open) {
            setIsOpen(true);
        } else {
            const timer = setTimeout(() => setIsOpen(false), 200);
            return () => clearTimeout(timer);
        }
    }, [open]);

    const handleCloseWithAnimation = () => {
        if (isLoading) return;
        setIsOpen(false);
        setTimeout(handleClose, 200);
    };

    const handleConfirmWithAnimation = () => {
        if (isLoading) return;
        setIsOpen(false);
        setTimeout(handleConfirm, 200);
    };

    const handleCancelWithAnimation = () => {
        if (isLoading) return;
        setIsOpen(false);
        setTimeout(handleCancel || (() => {}), 200);
    };

    const contentArray = contentText ? contentText.split("\n").filter(Boolean) : [];

    return (
        <Modal
            open={open}
            onClose={handleCancelWithAnimation}
            closeAfterTransition
            BackdropComponent={StyledBackdrop}
            BackdropProps={{
                timeout: 500,
                onClick: (e) => e.stopPropagation(),
            }}
        >
            <ModalWrapper isOpen={isOpen}>
                <TitleWrapper>
                    <WarningIcon />
                    <TitleText>{title}</TitleText>
                    <WarningText>
                        {contentArray.map((line: string, index: number) => (
                            <div key={index} style={{ marginBottom: line.trim().startsWith("-") ? "4px" : "8px" }}>
                                {line.trim()}
                            </div>
                        ))}
                    </WarningText>
                </TitleWrapper>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "16px", marginTop: "24px" }}>
                    <CustomButton
                        title={closeButtonText}
                        onClick={handleCloseWithAnimation}
                        variant="outlined"
                        disabled={isLoading}
                        style={{
                            paddingTop: 8,
                            paddingBottom: 8,
                            paddingLeft: 14,
                            paddingRight: 14,
                            display: "flex",
                            justifyContent: "center",
                            minWidth: "120px",
                            height: "36px",
                            borderRadius: "5px",
                            fontSize: "14px",
                            gap: 6,
                        }}
                    />
                    {showCancelButton && (
                        <CustomButton
                            title={cancelButtonText}
                            onClick={handleCancelWithAnimation}
                            variant="outlined"
                            disabled={isLoading}
                            style={{
                                paddingTop: 8,
                                paddingBottom: 8,
                                paddingLeft: 14,
                                paddingRight: 14,
                                display: "flex",
                                justifyContent: "center",
                                minWidth: "120px",
                                height: "36px",
                                borderRadius: "5px",
                                fontSize: "14px",
                                gap: 6,
                            }}
                        />
                    )}
                    <CustomButton
                        title={confirmButtonText}
                        variant="contained"
                        onClick={handleConfirmWithAnimation}
                        isLoading={isLoading}
                        style={{
                            paddingTop: 8,
                            paddingBottom: 8,
                            paddingLeft: 14,
                            paddingRight: 14,
                            display: "flex",
                            justifyContent: "center",
                            minWidth: "120px",
                            height: "36px",
                            borderRadius: "5px",
                            fontSize: "14px",
                            gap: 6,
                            ...(dangerous && {
                                backgroundColor: color.status.FAIL,
                                color: "#FFFFFF",
                            }),
                        }}
                        sx={
                            dangerous
                                ? {
                                      "&:hover": {
                                          backgroundColor: "#B80015",
                                      },
                                  }
                                : undefined
                        }
                    />
                </div>
            </ModalWrapper>
        </Modal>
    );
};

export default CancelModal;
